import * as runtime from '@/api/runtime'
import {
  BatchReserveReturnWaitingCollectionForwardingCandidateListRequest,
  BatchReserveReturnWaitingCollectionForwardingCandidateListRequestToJSON,
  BatchStatisticsPageLoadRequest,
  BatchStatisticsPageLoadRequestToJSON
} from '@/api/models/batch'
import {
  BatchReserveReturnWaitingCollectionForwardingCandidateListCondition,
  BatchReserveReturnWaitingCollectionForwardingCandidateListConditionFromJSON
} from '@/api/models/batch/BatchReserveReturnWaitingCollectionForwardingCandidateListCondition'

/**
 * 帳票作成
 */
export class BatchReserveReturnWaitingCollectionForwardingCandidateListApi extends runtime.BaseAPI {
  async return(
    request: BatchReserveReturnWaitingCollectionForwardingCandidateListRequest
  ): Promise<number> {
    const response = await this.requestPost(
      `/batch/reserve/return-waiting-collection-forwarding-candidate-list`,
      BatchReserveReturnWaitingCollectionForwardingCandidateListRequestToJSON(
        request
      )
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }

  async getInitialCondition(
    request: BatchStatisticsPageLoadRequest
  ): Promise<
    BatchReserveReturnWaitingCollectionForwardingCandidateListCondition
  > {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchReserveReturnWaitingCollectionForwardingCandidateListConditionFromJSON(
        jsonValue
      )
    ).value()
  }
}
